import { cx } from '@emotion/css';
import { Col } from 'antd';
import { useSelector } from 'react-redux';
import { Order } from 'src/models';
import { BaseStyle, Spacing } from 'src/styles';

import { CurrencyField } from '../CurrencyField/CurrencyField';
import { MButton } from '../MButton/MButton';
import { MFormTextField } from '../MFormTextField/MFormTextField';
import { MModalBody, MModalFooter, MModalTitle } from '../MModal/SinglePageModal';
import { MTypography } from '../MTypography/MTypography';
import { SubmissionResult } from '../SubmissionResult/SubmissionResult';

import { ChangeOrderFormValues } from './ChangeOrderStep';

interface ChangeOrderFailedStepProps {
  order: Order;
  values: ChangeOrderFormValues;
  onClose: () => void;
}

export const ChangeOrderFailedStep = ({ order, values, onClose }: ChangeOrderFailedStepProps) => {
  const error = useSelector((state: any) => state.orders.update.error);

  return (
    <>
      <MModalTitle>Security Order Change Failed</MModalTitle>
      <MModalBody>
        <Col span={24} className={cx(BaseStyle.level, Spacing.my12)}>
          <SubmissionResult type='error' message={error?.message} testId={'change-order-failed'} />
        </Col>
        <Col span={24} className={cx(BaseStyle.level, Spacing.my24)} data-testid={'change-order-failed-symbol'}>
          <MTypography variant='h6' align='center'>
            {order.symbol}
          </MTypography>
        </Col>
        <Col span={24}>
          <MFormTextField label='Order Type' value={order.type.label} testId='change-order-failed-order-type' />
        </Col>
        <Col span={24}>
          <MFormTextField label='Share Quantity' value={order.quantity} testId='change-order-failed-quantity' />
        </Col>
        {order.type.isLimit || order.type.isStopLimit ? (
          <Col span={24}>
            <MFormTextField
              label='Limit Price'
              value={<CurrencyField value={values.price} />}
              testId='change-order-failed-limit-price'
            />
          </Col>
        ) : null}
        {order.type.isStopMarket || order.type.isStopLimit ? (
          <Col span={24}>
            <MFormTextField
              label='Stop Price'
              value={<CurrencyField value={values.stop} />}
              testId='change-order-failed-stop-price'
            />
          </Col>
        ) : null}
        <Col span={24}>
          <MFormTextField
            label='Order Expiration'
            value={order.duration.label}
            testId='change-order-failed-order-expiration'
          />
        </Col>
      </MModalBody>
      <MModalFooter className={BaseStyle.levelRight}>
        <MButton onClick={onClose} testId='change-order-failed-close'>
          Close
        </MButton>
      </MModalFooter>
    </>
  );
};
